import React from "react";
import { Route } from "react-router-dom";
import routes from "@/router/index.js";

export default class BaseLayOut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let exactRoute = null;
        return (
            <React.Fragment>
                {/* <ul>
                    {
                        routes.map((val, index) => (
                            <li key={index}>
                                <Link to={val.path}>{val.pathName}</Link>
                            </li>
                        ))
                    }
                </ul> */}
                {routes.map((route, key) => {
                    if (route.exact) {
                        exactRoute = (
                            <Route
                                key={key}
                                exact
                                path={route.path}
                                component={route.component}
                            />
                        );
                    }
                    if (!route.exact) {
                        exactRoute = (
                            <Route
                                key={key}
                                path={route.path}
                                component={route.component}
                            ></Route>
                        );
                    }
                    return exactRoute;
                })}
            </React.Fragment>
        );
    }
}
